<article>
  <ng-content select="lib-product-card-bullet-list-header" />
  <section role="list">
    <ng-content select="lib-product-card-bullet-list-item" />
  </section>
</article>
